import React, { useState } from "react";
import {
  Container,
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Link,
} from "@mui/material";
import hostel2 from "../../assets/Images/hostel2.jpg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axiosInstance from "../../lib/axios";

const ChangeResidentPwd = () => {
  const navigate = useNavigate();
  const [ResidentId, setResidentId] = useState(localStorage.getItem("ResidentId"));
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickShowPassword = (field) => {
    if (field === "old") setShowOldPassword(!showOldPassword);
    if (field === "new") setShowNewPassword(!showNewPassword);
    if (field === "confirm") setShowConfirmPassword(!showConfirmPassword);
  };

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    try {
      const response = await axiosInstance.post(
        `ResidentMst/ChngPwsResident`,
        {
          ResidentId: parseInt(ResidentId),
          NewPwd: newPassword,
          OldPwd: oldPassword,
        }
      );
      const {
        data: { Status, Message },
      } = response;

      if (response.data.Status === 0 && Message) {
        toast.success(Message, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        toast.error(Message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Password change error:", error);
    }
  };

  return (
    <Box>
      <ToastContainer />
      <Container container className="main_container_changepassword">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          className="middle"
          sx={{ marginTop: "10px" }}
        >
          <Grid item xs={12} md={6} className="chnage_pass">
            <Box display="flex" flexDirection="column" justifyContent="center">
            
              <Typography
                variant="h5"
                gutterBottom
                className="mb-4"
                sx={{
                  fontSize: {
                    xs: "1.2rem",
                    sm: "1.5rem",
                    md: "1.8rem",
                  },
                  textAlign: { xs: "center", md: "left" },
                  whiteSpace: "nowrap",
                }}
              >
                Change Your Password
              </Typography>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 550,
                  color: "#29343d",
                  fontSize: "15px",
                  marginBottom: "5px",
                }}
              >
                Old Password
              </Typography>
              <TextField
                type={showOldPassword ? "text" : "password"}
                variant="outlined"
                placeholder="Enter your old password"
                fullWidth
                className="input_form"
                value={oldPassword}
                sx={{
                  "& .MuiOutlinedInput-input": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                }}
                onChange={(e) => setOldPassword(e.target.value)}
                InputProps={{
                  classes: {
                    input: "custom-placeholder",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleClickShowPassword("old")}
                        edge="end"
                      >
                        {showOldPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 550,
                  color: "#29343d",
                  fontSize: "15px",
                  marginTop: "12px",
                  marginBottom: "5px",
                }}
              >
                New Password
              </Typography>
              <TextField
                type={showNewPassword ? "text" : "password"}
                variant="outlined"
                placeholder="Enter your new password"
                fullWidth
                className="input_form"
                value={newPassword}
                sx={{
                  "& .MuiOutlinedInput-input": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                }}
                onChange={(e) => setNewPassword(e.target.value)}
                InputProps={{
                  classes: {
                    input: "custom-placeholder",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleClickShowPassword("new")}
                        edge="end"
                      >
                        {showNewPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 550,
                  color: "#29343d",
                  fontSize: "15px",
                  marginTop: "12px",
                  marginBottom: "5px",
                }}
              >
                Confirm New Password
              </Typography>
              <TextField
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                placeholder="Confirm your new password"
                fullWidth
                className="input_form"
                value={confirmPassword}
                sx={{
                  "& .MuiOutlinedInput-input": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                }}
                onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{
                  classes: {
                    input: "custom-placeholder",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleClickShowPassword("confirm")}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                onClick={handleChangePassword}
                className="button_signin"
                variant="contained"
                fullWidth
                style={{ marginTop: 16 }}
              >
                Change Password
              </Button>
              <Typography variant="body2" style={{ marginTop: 16 }}>
                Return to <Link href="/resident-profile">Dashboard</Link>
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ textAlign: "center" }}
            sx={{
              display: { xs: "none", md: "block" },
            }}
          >
            <Box
              component="img"
              src={hostel2}
              alt="Feature Rich 3D Charts"
              style={{ width: "200px", marginTop: "" }}
            />
            <Typography variant="h6" gutterBottom>
              Feature Rich 3D Charts
            </Typography>
            <Button
              variant="outlined"
              style={{
                marginTop: 6,
                backgroundColor: "#635bff",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              Learn More
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ChangeResidentPwd;
